// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Router from 'vue-router'
// 样式重置
import '@/styles/reset.css';
// 共用样式
import '@/styles/common.css';
// iocn图标
import './assets/icon/iconfont.css';
// 引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 全局注册组件
import HeaderComponent from '@/components/common/header/HeaderComponent.vue';
import MenuComponent from '@/components/common/menu/MenuComponent.vue';
import CrumbsComponent from '@/components/common/crumbs/CrumbsComponent.vue';
Vue.component('HeaderComponent', HeaderComponent);
Vue.component('MenuComponent', MenuComponent);
Vue.component('CrumbsComponent', CrumbsComponent);

// 引入axios
import axios from 'axios';
Vue.prototype.$axios = axios;
// 引入接口文件
import urls from '@/ws/apiUrl.js';
Vue.prototype.$urls = urls;
// 引入共用方法
import commonMethods from '@/common/commonMethods.js';
Vue.prototype.$cm = commonMethods;
import bus from '@/common/eventBus.js';
Vue.prototype.$bus = bus;
import store from '@/vuex/store.js';

// 自定义指令
// Vue.directive('clickoutside', {
//   bind: function(el, binding, vnode) {
//     console.log(el, binding, vnode);
//     el.clickOutsideEvent = function(ev) {
//       console.log(ev)
//     }
//     document.body.addEventListener('click', el.clickOutsideEvent, true);
//   }
// });

Vue.config.productionTip = false

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

// 引入websocket
// import { init } from '@/ws/websocket.js';
// Vue.prototype.ws = init();
// console.log(Vue.prototype.ws)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js